@if (aberto) {
  <div class="filtro-painel">
    <div class="filtro-painel-grid">
      <ng-content></ng-content>
    </div>
  </div>
}

@if (visualizaFiltrosAplicados && tags.length > 0) {
  <div class="filtro-tags-aplicados">
    <span class="filtro-tags-aplicados-titulo">Filtros Aplicados:</span>
    <div class="flex-row gap-8">
      @for (tag of tags; track tag.chave) {
        <span class="filtro-tag-aplicado" [title]="tag.texto">
          <span class="filtro-tag-aplicado-texto">{{ tag.texto }}</span>
          <button type="button" class="filtro-tag-aplicado-remover" (click)="removerTag.emit(tag.chave)">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      }
    </div>
  </div>
}
